<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-type-dedication element-without-heading" id="dedication">
<div class="text" id="dedication-text">
<div class="alignment-block alignment-block-align-center">
<p class="alignment-block-content alignment-block-content-center dedication-content">For the Huddersfield-based side of our <span class="last-word">family</span>:</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Matt, Richelle, Katie, <span class="last-word">Melissa</span></p>
<p class="alignment-block-content alignment-block-content-center dedication-content">and our first great-grandchild, Lily <span class="last-word">Grace</span>.</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">You light up our <span class="last-word">lives</span>.</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6f0dc4ec